import styled from 'styled-components'
import { Spinner, Icon } from '@blueprintjs/core'

const InlineSpinnerIcon = styled(Spinner).attrs({
  size: 20,
})({
  display: 'inline-flex',
})

export default InlineSpinnerIcon
